<template>
	<v-layout>
		<v-flex sm12 md6 class="mb-5">
			<p class="add-event-step-header">Schedule and Format</p>
			<div v-if="getAddEventProp('wrkprtyType') === 'wrkprty'">
				<p class="add-event-step-secondary-header mb-0">Select your event format</p>
				<p class="add-event-step-sub-header mb-3">Our wrkprty events come with premade formats that have been designed to make sure your guests use their time to the fullest. The chosen schedule will integrate with a timer that you can use duing your event to help ensure your guests stick to the plan.</p>
				<div @click="selectFormat(1, 0.75, '45 minute work sprints 15 minute breaks')" class="mb-3">
					<v-card :style="getFormatStyle(1)">
						<v-card-title class="pa-2">
							<p class="add-event-step-sub-header mb-0" style="color: #666">45 minute work sprints 15 minute breaks</p>
						</v-card-title>
						<v-card-text class="pa-3">
							<v-layout justify-center align-center fill-height>

								<div v-for="(block, index) in getFormat(0.75)" :key="index" :style="getFormatBlockStyle(block)">
									&nbsp;
								</div>
							</v-layout>
						</v-card-text>
					</v-card>
				</div>
				<div @click="selectFormat(2, 1.25, '1:15 work sprints 15 minute breaks')" class="mb-3">
					<v-card :style="getFormatStyle(2)">
						<v-card-title class="pa-2">
							<p class="add-event-step-sub-header mb-0" style="color: #666">1:15 work sprints 15 minute breaks</p>
						</v-card-title>
						<v-card-text class="pa-3">
							<v-layout justify-center align-center fill-height>
								<div v-for="(block, index) in getFormat(1.25)" :key="index" :style="getFormatBlockStyle(block)">
									&nbsp;
								</div>
							</v-layout>
						</v-card-text>
					</v-card>
				</div>
				<div @click="selectFormat(3, 1.75, '1:45 work sprints 15 minute breaks')" class="mb-3">
					<v-card :style="getFormatStyle(3)">
						<v-card-title class="pa-2">
							<p class="add-event-step-sub-header mb-0" style="color: #666">1:45 work sprints 15 minute breaks</p>
						</v-card-title>
						<v-card-text class="pa-3">
							<v-layout justify-center align-center fill-height>
								<div v-for="(block, index) in getFormat(1.75)" :key="index" :style="getFormatBlockStyle(block)">
									&nbsp;
								</div>
							</v-layout>
						</v-card-text>
					</v-card>
				</div>
			</div>
			<div v-else>
				<p class="add-event-step-secondary-header mb-2">You are hosting a {{getAddEventProp('wrkprtyType')}}. It's up to you to create the format for the event.</p>
				<p class="add-event-step-sub-header mb-0">You will be responsible for facilitating work time and break time for your guests. If you'd like to use one of our preset formats please select 'wrkprty' as your <a href="/host/add/event/type">Event Type</a></p>
			</div>
		</v-flex>
		<v-flex md4 offset-md1 hidden-sm-and-down class="pt-3">
			<v-card class="add-event-tip-box">
				<v-card-text class="p-relative pt-5">
					<div class="info-trapezoid p-absolute">
						<div class="info-content">
							<img src="/static/images/icon/light-bulb-gray.svg" width="40" />
						</div>
					</div>
					<div v-if="getAddEventProp('wrkprtyType') === 'wrkprty'">
						<p class="add-event-tip-title">Legend</p>
						<div style="display: flex; flex-direction: row; align-items: center;" class="mt-2">
							<div style="height: 13px; width: 13px; background-color: #9DFAC3; border-radius: 10px;"></div>
							<p class="add-event-tip-content mb-0 ml-3">Guest Arrival</p>
						</div>
						<div style="display: flex; flex-direction: row; align-items: center;" class="mt-2">
							<div style="height: 13px; width: 13px; background-color: #74cbf1; border-radius: 10px;"></div>
							<p class="add-event-tip-content mb-0 ml-3">Work Sprint</p>
						</div>
						<div style="display: flex; flex-direction: row; align-items: center;" class="mt-2">
							<div style="height: 13px; width: 13px; background-color: #2CA0D2; border-radius: 10px;"></div>
							<p class="add-event-tip-content mb-0 ml-3">Break</p>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	data() {
		return {
			formatSelection: 0.75,
		}
	},
	beforeRouteLeave(to, from, next) {
		if (this.format !== null) {
			this.setAddEventValidStep(from.path)
			this.removeAddEventInvalidStep(from.path)
		} else {
			this.removeAddEventValidStep(from.path)
			this.setAddEventInvalidStep(from.path)
		}
		next()
	},
	methods: {
		...mapActions([
			'setAddEventProp',
			'setAddEventValidStep',
			'removeAddEventValidStep',
			'setAddEventInvalidStep',
			'removeAddEventInvalidStep',
		]),
		getFormatStyle (value) {
			let height = '100px!important'
			let border = ''
			let shadow = ''
			if (value === this.selectedFormat) {
				border = '#74cbf1'
				shadow = '0 0 10px ' + border
			} else {
				border = 'lightgray'
			}
			return {
				'min-height': height,
				'max-width': '88vw',
				'border': '1px solid ' + border,
				'box-shadow': shadow,
				'cursor': 'pointer'
			}
		},
		getFormatBlockStyle(block) {
			let color = ''
			let width = ''
			if (block.type === 'break') {
				color = '#2CA0D2'
			} else if (block.type === 'arrival') {
				color = '#9DFAC3'
			} else {
				color = '#74cbf1'
			}
			width = Math.round(block.duration * 80)
			// let leftRadius = '10px'
			// let rightRadius = '10px'
			// if (index === 0) {
			// 	leftRadius = '10px'
			// } else if (index === length - 1) {
			// 	rightRadius = '10px'
			// }
			let style = {
				'background-color': color,
				// 'border-radius': leftRadius + ' ' + rightRadius + ' ' + rightRadius + ' ' + leftRadius,
				'border-radius': '10px',
				'width': width + 'px!important',
				'height': '13px',
				'display': 'inline-block',
				'margin-right': '3px'
			}
			return style
		},
		selectFormat (index, duration, description) {
			this.selectedFormat = index
			this.format = this.getFormat(duration)
			this.setAddEventProp({prop: 'formatDescription', value: description})
		},
		getFormat (workSprintDuration) {
			let duration = this.getEventDuration
			let start = this.getAddEventProp('startTime')
			let end = this.getAddEventProp('endTime')
			let format = []
			let safety = 1000
			while (duration > 0 && safety > 0) {
				let type = ''
				let time = 0
				if (format.length === 0) {
					type = 'arrival'
					time = 0.75
				} else {
					if (format[format.length - 1].type === 'arrival') {
						type = 'break'
						time = 0.25
					} else if (format[format.length - 1].type === 'work') {
						type = 'break'
						time = 0.25
					} else if (format[format.length - 1].type === 'break') {
						type = 'work'
						time = workSprintDuration
					}
				}
				// check for the end of the event
				if (duration - time < 0) {
					if (type === 'work') {
						// wrkprty should be ended with a break so check if this workblock has enough time to be split into work and break
						if (duration > 0.25) {
							if (duration <= 0.5) {
								format[format.length - 2].duration += duration - 0.25
								format[format.length - 1].duration += 0.25
							} else {
								format.push({'type': 'work','duration': duration - 0.25})
								format.push({'type': 'break','duration': 0.25})
							}
						} else {
							// if not, just extend the last break
							format[format.length - 1].duration += duration
						}
					} else {
						if (duration > 0.25) {
							format[format.length - 1].duration -= 0.25
							format.push({'type': 'break','duration': 0.25})
						} else {
							format.push({'type': 'break','duration': duration})
						}
					}
					duration = 0
				} else {
					duration -= time
					format.push({'type': type, 'duration': time})
				}
				safety -= 1
			}
			return format
		}
	},
	computed: {
		...mapGetters(['getAddEventProp', 'getEventDuration']),
		format: {
			get () {
				return this.getAddEventProp('format')
			},
			set (val) {
				this.setAddEventProp({prop: 'format', value: val})
			}
		},
		selectedFormat: {
			get () {
				return this.getAddEventProp('formatIndex')
			},
			set (val) {
				this.setAddEventProp({prop: 'formatIndex', value: val})
			}
		}
	}
}
</script>

<style>
.formatDisplay {
	height: 200px!important;
	border: 1px solid lightgray;
}
.formatDisplaySelected {
	height: 200px!important;
	border: 1px solid blue;
}
</style>
